'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGoogleRecaptcha = require('react-google-recaptcha');

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Recaptcha = (_temp = _class = function (_React$Component) {
    (0, _inherits3.default)(Recaptcha, _React$Component);

    function Recaptcha(props) {
        (0, _classCallCheck3.default)(this, Recaptcha);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Recaptcha.__proto__ || (0, _getPrototypeOf2.default)(Recaptcha)).call(this, props));

        _this.siteKey = props.siteKey;
        _this.onchange = function (value) {
            (0, _jquery2.default)(".captcha-button").removeClass("btn--inactive").prop('disabled', false);
        };
        _this.onexpired = function () {
            (0, _jquery2.default)(".captcha-button").addClass("btn--inactive").prop('disabled', true);
        };
        return _this;
    }

    (0, _createClass3.default)(Recaptcha, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactGoogleRecaptcha2.default, {
                    sitekey: this.siteKey,
                    type: 'image',
                    theme: 'light',
                    onChange: function onChange(value) {
                        return _this2.onchange(value);
                    },
                    onExpired: function onExpired(value) {
                        return _this2.onexpired();
                    } })
            );
        }
    }]);
    return Recaptcha;
}(_react2.default.Component), _class.propTypes = {
    siteKey: _propTypes2.default.string.isRequired
}, _temp);
exports.default = Recaptcha;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/recaptcha/recaptcha.js
// module id = 1091
// module chunks = 0